export type PricingTier = {
  currency: string
  symbol: string
  offer: string
  regular: string
  total: string
  bonuses: {
    b1: string
    b2: string
    b3: string
    b4: string
    b5: string
  }
  values: {
    system: string
    protocol: string
    guide: string
    plans: string
  }
}

const pricing: PricingTier = {
  currency: 'ARS',
  symbol: '',
  offer: '14.990',
  regular: '42.000',
  total: '84.980',
  bonuses: { b1: '8.990', b2: '6.990', b3: '12.000', b4: '8.000', b5: '7.000' },
  values: {
    system: '28.000',
    protocol: '6.500',
    guide: '3.500',
    plans: '4.000',
  },
}

export function usePricing() {
  return { pricing, isLoaded: true }
}
